import React from "react";
import { BarChart3 } from "lucide-react";

const MainLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white">
      <div className="relative flex items-center justify-center">
        <div className="absolute h-24 w-24 rounded-full border-4 border-violet-100" />
        <div className="absolute h-24 w-24 rounded-full border-4 border-transparent border-t-violet-500 border-r-indigo-400 animate-spin" />
        <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-violet-500 to-indigo-400 flex items-center justify-center shadow-lg shadow-violet-200 animate-pulse">
          <BarChart3 className="h-7 w-7 text-white" strokeWidth={2.25} />
        </div>
      </div>

      <div className="mt-6 flex flex-col items-center gap-1">
        <h1 className="text-lg font-semibold tracking-tight text-slate-800">
          Sales Hub
        </h1>
        <p className="text-sm text-slate-400">Loading your dashboard…</p>
      </div>

      <div className="mt-5 flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-violet-400 animate-bounce [animation-delay:-0.3s]" />
        <span className="h-1.5 w-1.5 rounded-full bg-violet-400 animate-bounce [animation-delay:-0.15s]" />
        <span className="h-1.5 w-1.5 rounded-full bg-violet-400 animate-bounce" />
      </div>
    </div>
  );
};

export default MainLoader;
